var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('strong', {
    staticClass: "price",
    class: {
      'medium': _vm.size === 'medium',
      'bold': _vm.size === 'bold'
    }
  }, [_vm._v("¥ "), _c('b', [_vm._v(_vm._s(_vm.price.indexOf(".") !== -1 ? parseInt(_vm.price.substring(0, _vm.price.indexOf("."))) : _vm.price))]), _c('em', [_vm._v(_vm._s(_vm.price.indexOf(".") !== -1 ? _vm.price.substring(_vm.price.indexOf("."), _vm.price.length) : '.00'))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };